<template>
  <el-collapse v-model="activeName" accordion class="answer-list-collapse">
    <el-collapse-item
      v-for="answer in answerList"
      :name="answer.id"
      :key="answer.id"
      class="answer-list-collapse-item"
    >
      <template slot="title">
        <div class="collapse-title">
          <i class="el-icon-notebook-1 title-icon"></i>
          <span class="title-text">{{ answer.student_name }}</span>
          <GradeTag :score="answer.score" v-if="answer.score!==null" />
        </div>
      </template>
      <div class="collapse-content">
        <div class="content-description">Student ID: {{ answer.student_id }}</div>
        <MarkdownDisplay :value="answer.description" withMaxHeight />
        <FileDownloadCard v-if="answer.attachment" :href="answer.attachment" />
      </div>
      <div class="button-group">
        <el-button
          round
          type="primary"
          @click="openDialog(answer.id)"
        >Set Grades</el-button>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import MarkdownDisplay from "@/atoms/MarkdownDisplay.vue";
import FileDownloadCard from "@/atoms/FileDownloadCard.vue";
import GradeTag from "@/atoms/GradeTag.vue";
import { setAnswerScore } from "@/api";

export default {
  name: "AnswerCollapseList",
  components: {
    MarkdownDisplay,
    FileDownloadCard,
    GradeTag
  },
  data() {
    return {
      activeName: ""
    };
  },
  methods: {
    openDialog(answerId) {
      this.$prompt("Please input the score", "Determine the Grades", {
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: "Invalid Score!"
      })
        .then(({ value }) => {
          setAnswerScore(answerId, Number(value)).then(res => {
            if (res.status === "succeed") {
              this.$message({
                type: "success",
                message: "Score updated."
              });
            } else {
              this.$message({
                type: "error",
                message: res.message
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Action Canceled."
          });
        });
    }
  },
  props: {
    answerList: Array
  }
};
</script>

<style lang="scss">
.answer-list-collapse {
  border: none !important;
}
.answer-list-collapse-item {
  margin: 8px 0;
  border-radius: 12px;
  overflow: hidden;
  &:hover,
  &:focus,
  &.is-active {
    box-shadow: 0 0 5px #909399;
  }
  * {
    border: none !important;
  }
}
.el-collapse-item__header {
  padding: 8px 16px;
  &.is-active {
    background-color: #e4f7fb;
  }
  .collapse-title {
    flex-grow: 1;
    display: flex;
    .title-icon {
      line-height: inherit;
      padding-right: 12px;
    }
    .title-text {
      font-size: 16px;
      font-weight: 600;
      flex-grow: 1;
    }
    .expire-time {
      padding-right: 16px;
    }
  }
}
.collapse-content {
  padding: 8px 16px;
  .content-description {
    font-size: 14px;
    margin-bottom: 8px;
    color: #a2a2a2;
  }
}
.button-group {
  padding: 8px 16px;
  text-align: right;
  > * {
    margin-left: 16px;
  }
}
</style>